import { ChangeDetectionStrategy, Component } from "@angular/core";
import { LookerMemberManagementDashboardType } from "../../looker-member-management-dashboard-type.enum";
import { HideFilters } from "../../models/analytics-hide-filters.enum";

@Component({
  selector: "app-payment-adjustment-dashboard",
  templateUrl: "./payment-adjustment-dashboard.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PaymentAdjustmentDashboardComponent {
filters: string[] = ["Projects"];
dashboardType = LookerMemberManagementDashboardType.PaymentAdjustmentDashboardDW;
hideFilters: string[] = [HideFilters.PROJECT_ID, HideFilters.USER_ID, HideFilters.ORG_ID, HideFilters.CUSTOMER_NAME2];
}
